/// <reference types="vite/types/importMeta" />
import { apiPathFn } from "@ntprsrf-frontend/common/src/utils/api";
import { Axios } from "axios-observable";
import { map } from "rxjs";
import { ListCompanyRequest } from "../../requests/intranet/company.request";
import {
  CompanyDetailResponse,
  ListCompanyResponse,
} from "../../responses/internet/company.response";

const apiPath = apiPathFn(import.meta.env.VITE_COMPANY_SERVICE);

export function listCompany(params: Partial<ListCompanyRequest>) {
  return Axios.get<ListCompanyResponse>(apiPath(["list"]), {
    params: {
      ...params,
      eGuaranteeTypes: params.eGuaranteeTypes
        ? params.eGuaranteeTypes.join(",")
        : undefined,
      searchEGuaranteeType: params.searchEGuaranteeType,
    },
  }).pipe(map((response) => response.data));
}

export function getCompanyDetailsByUEN(companyUEN: string) {
  return Axios.post<CompanyDetailResponse>(apiPath(["UEN", companyUEN])).pipe(
    map((response) => response.data)
  );
}
